import request from "@utils/request";

/**
 * 获取团购详情
 */
export function getPurchaseView(id) {
  return request.get(`/purchase/view/${id}`, { login: false });
}
/**
 * 拼团列表
 */
export function findGroupbugList(shopId) {
  return request.get(`/wap/groupbuy/list/${shopId}`, {}, { login: false });
}
/**
 * 拼团列表
 */
export function getGroupbugDetail(groupbuyId) {
  return request.get(`/wap/groupbuy/list/${groupbuyId}`, {}, { login: false });
}

/**
 * 拼团产品详情
 * @param id
 */
export function getCombinationDetail(id) {
  return request.get("/combination/detail/" + id, {}, { login: false });
}

/**
 * 拼团 开团
 * @param {*} id
 */
export function getCombinationPink(id) {
  return request.get("/combination/pink/" + id);
}

/**
 * 拼团 取消开团
 */
export function getCombinationRemove(data) {
  return request.post("/combination/remove", data);
}

/**
 * 拼团海报
 * @param {*} id
 */
export function getCombinationPoster(data) {
  return request.post("/combination/poster", data);
}

/**
 * 秒杀列表配置
 */
export function getSeckillConfig() {
  return request.get("/seckill/index", {}, { login: false });
}

/**
 * 秒杀列表
 */
export function getSeckillList(time, data) {
  return request.get("/seckill/list/" + time, data, { login: false });
}

/**
 * 秒杀产品详情
 */
export function getSeckillDetail(id) {
  return request.get("/seckill/detail/" + id, {}, { login: false });
}

/**
 * 砍价列表
 * @param {*} data
 */
export function getBargainList(data) {
  return request.get("/bargain/list", data, { login: false });
}

/**
 * 砍价产品详情
 */
export function getBargainDetail(id) {
  return request.get("/bargain/detail/" + id);
}

/**
 * 砍价 观看/分享/参与次数
 */
export function getBargainShare(data) {
  return request.post("/bargain/share", data);
}

/**
 * 砍价开启
 * @param {*} data
 */
export function getBargainStart(data) {
  return request.post("/bargain/start", data);
}

/**
 * 砍价 帮助好友砍价
 * @param {*} data
 */
export function getBargainHelp(data) {
  return request.post("/bargain/help", data);
}

/**
 * 砍价 砍掉金额
 * @param {*} data
 */
export function getBargainHelpPrice(data) {
  return request.post("/bargain/help/price", data);
}

/**
 * 砍价 砍价帮总人数、剩余金额、进度条、已经砍掉的价格
 * @param {*} data
 */
export function getBargainHelpCount(data) {
  return request.post("/bargain/help/count", data);
}

/**
 * 砍价 开启砍价用户信息
 * @param {*} data
 */
export function getBargainStartUser(data) {
  return request.post("/bargain/start/user", data);
}

/**
 * 砍价 砍价帮
 * @param {*} data
 */
export function getBargainHelpList(data) {
  return request.post("/bargain/help/list", data);
}

/**
 * 砍价海报
 * @param {*} data
 */
export function getBargainPoster(data) {
  return request.post("/bargain/poster", data);
}

/**
 * 砍价列表(已参与)
 * @param {*} data
 */
export function getBargainUserList(data) {
  return request.get("/bargain/user/list", data);
}

/**
 * 砍价取消
 */
export function getBargainUserCancel(data) {
  return request.post("/bargain/user/cancel", data);
}

/**
 * 获得活动
 *
 */
export function getIndentSales(activityId) {
  return request.get(`/indent/sales/${activityId}`);
}

/**
 * 获得活动
 *
 */
export function get(activityId) {
  return request.get(`/wap/activity/get/${activityId}`, {});
}
/**
 * 创建订单
 *
 */
export function createOrder(param) {
  return request.post(`/wap/activity/create/order`, param);
}
/**
 * 推广活动绑定推广员
 *
 */
export function bindSpread(activityId, spread) {
  return request.post(`/wap/activity/bind/${activityId}/${spread}`, {});
}
/**
 * 获取活动推广图片
 *
 */
export function getSpreadImage(activityId) {
  return request.get(`/wap/activity/spread/image/${activityId}`, {});
}
/*
 * 推广人列表
 * */
export function getSpreadUser(activityId, page) {
  return request.post(`/wap/activity/spread/people/${activityId}`, page);
}
/*
 * 推广人订单
 * */
export function getSpreadOrder(activityId, page) {
  return request.post(`/wap/activity/spread/order/${activityId}`, page);
}
/*
 * 佣金明细
 * */
export function getCommissionInfo(activityId, page) {
  return request.post(`/wap/activity/commission/${activityId}`, page);
}
/*
 * 佣金总额
 * */
export function commissionTotal(activityId) {
  return request.get(`/wap/activity/commission/total/${activityId}`);
}
/*
 * 今日佣金
 * */
export function nowCommission(activityId) {
  return request.get(`/wap/activity/commission/now/${activityId}`);
}
/*
 * 昨日佣金
 * */
export function yesterdayCommission(activityId) {
  return request.get(`/wap/activity/commission/yesterday/${activityId}`);
}
/*
 * 推广人排行
 */
export function fetchPromoterRank(activityId, page) {
  return request.post(`/wap/activity/promoter/rank/${activityId}`, page);
}
/*
 * 佣金排行
 */
export function fetchCommissionRank(activityId, page) {
  return request.post(`/wap/activity/commission/rank/${activityId}`, page);
}
/*
 * 获取活动参与人数
 */
export function fetchBrowseUser(activityId) {
  return request.get(`/wap/activity/get/browse/${activityId}`);
}
